export default "__VITE_ASSET__770780cd__"